import { FileWithPath } from '@mantine/dropzone';
import { notifications } from '@mantine/notifications';
import { FileRejection } from '@/types';
import { useNotify } from '@/hooks';
import { t } from 'i18next';

export const useFileDrop = (load: (files: File[]) => void) => {
  const { error } = useNotify();

  const handleFileAccept = (files: FileWithPath[]) => {
    if (files.length === 0) {
      error(t('message.error.noFileSelected'));
      return;
    }

    load(files);
  };

  const handleFileReject = (rejections: FileRejection[]) => {
    rejections.forEach((rejection) => {
      rejection.errors.forEach((error) => {
        notifications.show({
          title: 'Error loading file',
          message: error.message,
        });
      });
    });
  };

  return {
    handleFileAccept,
    handleFileReject,
  };
};
